import React from 'react';
import { IAppConfiguration } from './interfaces/IAppConfiguration';

export interface IAppConfigurationSuperset extends IAppConfiguration {
  [key: string]: any;
}

export const AppConfigurationContext = React.createContext<IAppConfigurationSuperset | null>(null);
